import API from '@/api';
import get from 'lodash/get';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      signatureStatuses: [
        {
          value: 'sending',
          text: 'Sending',
          icon: 'email',
          class: 'grey--text',
        },
        {
          value: 'sent',
          text: 'Sent',
          icon: 'email',
          class: 'primary--text',
        },
        {
          value: 'signed',
          text: 'Signed',
          icon: 'check_circle',
          class: 'success--text',
        },
        {
          value: 'completed',
          text: 'Completed',
          icon: 'done_all',
          class: 'success--text',
        },
        {
          value: 'error',
          text: 'Error',
          icon: 'cancel',
          class: 'error--text',
        },
        {
          value: 'rejected',
          text: 'Rejected',
          icon: 'cancel',
          class: 'error--text',
        },
        {
          value: 'processing',
          text: 'Processing',
          icon: 'circle',
          class: 'grey--text',
        },
        {
          value: 'action_required',
          text: 'Action required',
          icon: 'warning',
          class: 'warning--text',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },

  methods: {
    getSignatureStatus(signature) {
      return this.signatureStatuses.find(s => s.value == signature.status);
    },

    async resend(item) {
      try {
        const subject = item.subject
          ? item.subject
          : 'Please sign ' + this.getName(item);

        const message = item.message
          ? item.message
          : `Hi {client_preferred_name},\nPlease click the button below to review the document and sign it. Thank you very much.\n\nBest regards,\n${this.currentUser.full_name}`;

        await API.signatureRequest.sendSignatureRequest({
          companyId: item.company_id,
          id: item.id,
          signatures: item.signatures,
          pages: item.pages,
          subject: subject,
          message: message,
          includeWatermark: item.includeWatermark,
        });

        this.$store.dispatch('application/setSuccessNotification', {
          message: `You have successfully sent signature requests!`,
        });
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: `There was a problem sending signature request.`,
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      }
    },

    async remove(item) {
      await API.signatureRequest.deleteSignatureRequest({
        id: item.id,
        companyId: item.company_id,
      });

      await this.refreshTable();
    },

    async markAsCompleted(item) {
      await API.signatureRequest.updateSignatureRequest({
        id: item.id,
        companyId: item.company_id,
        status: 'completed',
      });

      await this.refreshTable();
    },

    getName(item) {
      if (item.form_name) {
        return item.form_name;
      } else {
        return this.getDocumentName(item.source);
      }
    },

    async downloadDocument(item) {
      try {
        const source = item.signed_document
          ? item.signed_document
          : item.source;

        const response1 = await API.integration.downloadDocument({
          companyId: item.company_id,
          link: source,
        });

        const name = this.getDocumentName(source);

        this.downloadDocumentByLink(response1.data.document.data.link, name);
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
        });
      }
    },

    async downloadSignedPagesOnly(item) {
      try {
        const source = item.signed_pages_only;

        const response1 = await API.integration.downloadDocument({
          companyId: item.company_id,
          link: source,
        });

        const name = this.getDocumentName(source);

        this.downloadDocumentByLink(response1.data.document.data.link, name);
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
        });
      }
    },

    getDocumentName(document) {
      return document.split('/')[document.split('/').length - 1];
    },

    async downloadDocumentByLink(url, name) {
      let response = await this.$http.get(url, { responseType: 'arraybuffer' });
      let blob = new Blob([response.data], {
        type: get(response.headers, 'content-type'),
      });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
    },
  },
};
